import { getToken, pointOfSaleApi, productApi } from "@repo/api-client";
import { useEffect, useRef } from "react";
import { Outlet, redirect } from "react-router";
import { Header } from "../components/header";
import { useNetworkStatus } from "@repo/ui/hooks/use-network-status";
import { processPendingSales } from "../utils/pending-sales";

function Layout() {
  // const matches = useMatches();
  const isOnline = useNetworkStatus();
  const wasOnlineRef = useRef<boolean | null>(null);
  const isProcessingRef = useRef(false);

  // const backLink = (
  //   matches.find((match: any) => {
  //     return match.handle?.backLink;
  //   })?.handle as any
  // )?.backLink;

  // Procesar ventas pendientes cuando se recupera la conexión o al cargar la app
  useEffect(() => {
    // Si es la primera vez (wasOnlineRef.current es null) y hay conexión, procesar
    // O si se recupera la conexión (de offline a online)
    const shouldProcess =
      isOnline &&
      !isProcessingRef.current &&
      (wasOnlineRef.current === null || wasOnlineRef.current === false);

    if (shouldProcess) {
      isProcessingRef.current = true;
      processPendingSales(productApi.createSaleItem)
        .then(() => {
          console.log("Pending sales processed successfully");
        })
        .catch((error) => {
          console.error("Error processing pending sales:", error);
        })
        .finally(() => {
          isProcessingRef.current = false;
        });
    }

    // Actualizar el estado previo de conexión
    if (wasOnlineRef.current === null || wasOnlineRef.current !== isOnline) {
      wasOnlineRef.current = isOnline;
    }
  }, [isOnline]);

  return (
    <div className="flex h-screen flex-col">
      {/* <Header backLink={backLink} /> */}
      <Header />
      <div className="flex-1 flex flex-col items-center justify-center gap-2 min-h-0 max-w-6xl mx-auto w-full px-4 relative">
        <Outlet />
      </div>
      <div className="text-center text-base text-primary w-full mb-1">
        playpadel.io
      </div>
    </div>
  );
}

export const posLayoutId = "pos-layout";

export const route = {
  id: posLayoutId,
  element: <Layout />,
  loader: async () => {
    const token = getToken();
    if (!token) {
      return redirect("/login");
    }
    return await pointOfSaleApi.getStartupData();
  },
};
